<p-tabView (onChange)="onTabChange($event)" [ngClass]="{'gltab': visibleFromModule != 'Finance'}">
    <p-tabPanel header="Overview">
        <div class="p-field p-formgrid p-grid">
            <div class="p-col-12 p-md-4">
                <div class="p-fluid">
                    <div class="card" style="min-height: 150px">
                        <h6 class="p-mb-0">Billing:</h6>
                        <span *ngIf="soDetails">
                            <p class="p-mb-0">
                                <span *ngIf="templates?.labels_billaddress[5]?.isChecked">
                                    {{ soDetails?.account?.sequenceNumber ? soDetails?.account?.sequenceNumber + " - " : "" }}
                                </span>
                                <span class="p-mb-0 acc-name-popup-link" (click)="onAccountViewClick(soDetails)" *ngIf="templates?.labels_billaddress?.[0]?.isChecked">
                                    {{ soDetails?.account?.businessName }}
                                </span>
                            </p>
                            <!-- Street -->
                            <p class="p-mb-0" *ngIf="templates?.labels_billaddress[1]?.isChecked">
                                {{ billingAddress?.address?.streetAddress1 }}
                                <span *ngIf="billingAddress?.address && billingAddress?.address?.streetAddress1 && billingAddress?.address?.streetAddress1 != '' && billingAddress?.address?.streetAddress2 && billingAddress?.address?.streetAddress2 != ''">,</span>
                                {{ billingAddress?.address?.streetAddress2 }}
                            </p>
                            <!--Address-->
                            <p class="p-mb-0" *ngIf="templates?.labels_billaddress[2]?.isChecked">
                                {{ billingAddress?.address?.city?.name }}
                                <span *ngIf="billingAddress?.address && billingAddress?.address?.city && billingAddress?.address?.city?.name && billingAddress?.address?.city?.name != '' && billingAddress?.address?.city?.state && billingAddress?.address?.city?.state?.name != ''">,</span>
                                {{ billingAddress?.address?.city?.state?.name }} <span *ngIf="billingAddress?.address && billingAddress?.address?.city && billingAddress?.address?.city?.state && billingAddress?.address?.city?.state?.name && billingAddress?.address?.city?.state?.name != '' && billingAddress?.address?.city?.state?.country && billingAddress?.address?.city?.state?.country?.name != ''">,</span>
                                {{ billingAddress?.address?.city?.state?.country?.name }}
                                <span *ngIf="billingAddress?.address && billingAddress?.address?.city && billingAddress?.address?.city?.state && billingAddress?.address?.city?.state?.country && billingAddress?.address?.city?.state?.country?.name && billingAddress?.address?.city?.state?.country?.name != '' && billingAddress?.address?.zipCode && billingAddress?.address?.zipCode != ''">,</span>
                                {{ billingAddress?.address?.zipCode }}
                            </p>
                            <!--billing contact-->
                            <p class="p-mb-0" *ngIf="templates?.labels_billaddress[3]?.isChecked"> {{ billingAddressContact?.firstName }} {{ billingAddressContact?.lastName ? " " : "" }} {{ billingAddressContact?.lastName }} </p>
                            <p class="p-mb-0" *ngIf="templates?.labels_billaddress[4]?.isChecked">
                                {{ billingAddressContact && billingAddressContact?.contactPhones && billingAddressContact?.contactPhones[0]?.phone && billingAddressContact?.contactPhones[0]?.phone?.number ? billingAddressContact?.contactPhones[0]?.phone?.number : "" }}
                            </p>
                        </span>
        
                        <!-- custom -->
                        <app-custom-attribute-overview [fieldType]="fieldTypes.FIELD" [customFieldData]="customFields.billing_address_item"> </app-custom-attribute-overview>
                    </div>
                </div>
            </div>
            <div class="p-col-12 p-md-4">
                <div class="p-fluid">
                    <div class="card" style="min-height: 150px">
                        <h6 class="p-mb-0">Shipping</h6>
                        <span *ngIf="soDetails">
                            <p class="p-mb-0">
                                <span *ngIf="templates?.labels_shipaddress[5]?.isChecked">
                                    {{ soDetails?.account?.sequenceNumber ? soDetails?.account?.sequenceNumber + " - " : "" }}
                                </span>
                                <!-- <span class="p-mb-0 acc-name-popup-link" (click)="onAccountViewClick(soDetails)"
                                    *ngIf="templates?.labels_shipaddress?.[0]?.isChecked">
                                    {{ soDetails?.account?.businessName }}
                                </span> -->
                                <span class="p-mb-0 acc-name-popup-link" *ngIf="templates?.labels_shipaddress?.[0]?.isChecked" (click)="onAccountViewClick(soDetails)">
                                    {{ shippingAddress?.address?.addressName && shippingAddress?.address?.addressName?.length > 0 ? shippingAddress?.address?.addressName : soDetails?.account?.businessName }}
                                </span>
                            </p>
                            <!-- Street -->
                            <p class="p-mb-0" *ngIf="templates?.labels_shipaddress?.[1]?.isChecked">
                                {{ shippingAddress?.address?.streetAddress1 }}
                                <span *ngIf="shippingAddress?.address && shippingAddress?.address?.streetAddress1 && shippingAddress?.address?.streetAddress1 != '' && shippingAddress?.address?.streetAddress2 && shippingAddress?.address?.streetAddress2 != ''">,</span>
                                {{ shippingAddress?.address?.streetAddress2 }}
                            </p>
                            <!--Address-->
                            <p class="p-mb-0" *ngIf="templates?.labels_shipaddress?.[2]?.isChecked">
                                {{ shippingAddress?.address?.city?.name }}
                                <span *ngIf="shippingAddress?.address && shippingAddress?.address?.city && shippingAddress?.address?.city?.name && shippingAddress?.address?.city?.name != '' && shippingAddress?.address?.city?.state && shippingAddress?.address?.city?.state?.name != ''">,</span>
                                {{ shippingAddress?.address?.city?.state?.name }} <span *ngIf="shippingAddress?.address && shippingAddress?.address?.city && shippingAddress?.address?.city?.state && shippingAddress?.address?.city?.state?.name && shippingAddress?.address?.city?.state?.name != '' && shippingAddress?.address?.city?.state?.country && shippingAddress?.address?.city?.state?.country?.name != ''">,</span>
                                {{ shippingAddress?.address?.city?.state?.country?.name }}
                                <span *ngIf="shippingAddress?.address && shippingAddress?.address?.city && shippingAddress?.address?.city?.state && shippingAddress?.address?.city?.state?.country && shippingAddress?.address?.city?.state?.country?.name && shippingAddress?.address?.city?.state?.country?.name != '' && shippingAddress?.address?.zipCode && shippingAddress?.address?.zipCode != ''">,</span>
                                {{ shippingAddress?.address?.zipCode }}
                            </p>
                            <!--shipping contact-->
                            <p class="p-mb-0" *ngIf="templates?.labels_shipaddress?.[3]?.isChecked"> {{ shippingAddressContact?.firstName }} {{ shippingAddressContact?.lastName ? " " : "" }} {{ shippingAddressContact?.lastName }} </p>
                            <p class="p-mb-0" *ngIf="templates?.labels_shipaddress?.[4]?.isChecked">
                                {{ shippingAddressContact && shippingAddressContact?.contactPhones && shippingAddressContact?.contactPhones[0]?.phone && shippingAddressContact?.contactPhones[0]?.phone?.number ? shippingAddressContact?.contactPhones[0]?.phone?.number : "" }}
                            </p>
                        </span>
        
                        <!-- custom -->
                        <app-custom-attribute-overview [fieldType]="fieldTypes.FIELD" [customFieldData]="customFields.shipping_address_item"> </app-custom-attribute-overview>
                    </div>
                </div>
            </div>
            <div class="p-col-12 p-md-4">
                <div class="p-fluid">
                    <div class="card" style="min-height: 150px">
                        <div style="display: flex; justify-content: space-between; align-items: flex-start; width: 100%">
                            <div style="display: flex; flex-direction: column; align-items: flex-start; width: 70%">
                                <p class="p-mb-0" *ngIf="templates?.labels_misc?.[0]?.isChecked">
                                    {{ templates?.labels_misc?.[0]?.labelname }}: {{ soDetails?.salesOrderDate | date: "MM/dd/yyyy" }}
                                </p>
                                <p class="p-mb-0" *ngIf="templates?.labels_misc?.[1]?.isChecked">
                                    {{ templates?.labels_misc?.[1]?.labelname }}: {{ soDetails?.number }}
                                </p>
                                <p class="p-mb-0" *ngIf="templates?.labels_misc?.[2]?.isChecked">
                                    {{ templates?.labels_misc?.[2]?.labelname }}: {{ soDetails?.salesOrderStage }}
                                </p>
                                <p class="p-mb-0" *ngIf="templates?.labels_misc?.[3]?.isChecked">
                                    {{ templates?.labels_misc?.[3]?.labelname }}: {{ soDetails?.salesOrderStatus }}
                                </p>
                                <p class="p-mb-0" *ngIf="templates?.labels_misc?.[4]?.isChecked">
                                    {{ templates?.labels_misc?.[4]?.labelname }}: {{ soDetails?.warehouse?.locationId }}
                                </p>
                                <p class="p-mb-0" *ngIf="templates?.labels_misc?.[5]?.isChecked">
                                    {{ templates?.labels_misc?.[5]?.labelname }}: {{ soDetails?.createdByUser }}
                                </p>
                                <p class="p-mb-0" *ngIf="templates?.labels_misc?.[6]?.isChecked">
                                    {{ templates?.labels_misc?.[6]?.labelname }}: {{ soDetails?.reference }}
                                </p>
                                <p class="p-mb-0" *ngIf="templates?.labels_misc?.[7]?.isChecked && soDetails?.salesOrderStageId == soStage.Shipped">
                                    {{ templates?.labels_misc?.[7]?.labelname }}:
                                    <span class="p-mb-0 acc-name-popup-link" (click)="navigateToInvoice(soDetails)">
                                        {{ soDetails?.invoiceNo }}
                                    </span>
                                    <span class="p-ml-1" *ngIf="soDetails?.invoiceDate">
                                        {{ soDetails?.invoiceDate | date: 'MM/dd/yyyy' }}
                                    </span>
                                </p>
                                <p class="p-mb-0" *ngIf="templates?.labels_misc?.[8]?.isChecked && soDetails && soDetails?.estimateId != 0">
                                    {{ templates?.labels_misc?.[8]?.labelname }}:
                                    <span class="p-mb-0 acc-name-popup-link" (click)="navigateToEstimate(soDetails)">
                                        {{ soDetails?.estimateNo }}
                                    </span>
                                    <span class="p-ml-1" *ngIf="soDetails?.estimateDate">
                                        {{ soDetails?.estimateDate | date: 'MM/dd/yyyy' }}
                                    </span>
                                </p>
                                <!-- Currency: -->
                                <p class="p-mb-0" *ngIf="templates?.labels_misc[9]?.isChecked && (baseCurrency?.currencyId !== soDetails?.account?.currencyId)">
                                    {{ templates?.labels_misc[9]?.labelname }}: 
                                    <span>1 {{ baseCurrency?.code }} = {{ soDetails?.exchangeRate }} {{ soDetails?.account?.currencyUnit?.code }}</span>
                                </p>
                                <!-- custom -->
                                <app-custom-attribute-overview [fieldType]="fieldTypes.FIELD" [customFieldData]="customFields?.misc_item"> </app-custom-attribute-overview>
                            </div>
        
                            <div style="display: flex; flex-direction: column; align-items: flex-end; width: 100%">
                                <div style="display: flex; flex-direction: row; justify-content: flex-end; width: 30%">
                                    <ng-container *ngIf="!showOrderVoidMsg">
                                        <span class="btnBars p-mr-0" (click)="createInvoiceTB()" *ngIf="showPickColumn && visibleFromModule == soChannel.SALES_ORDER && soDetails?.salesOrderStageId != soStage.Shipped && soDetails?.salesOrderStatusId != soStatus.Void">
                                            <i class="pi pi-plus-circle" pTooltip="{{ addBtnInfoTooltip }}" tooltipPosition="left"></i>
                                        </span>
                                        <span class="btnBars p-mr-2" pTooltip="Create Shipping Label" tooltipPosition="left" *ngIf="(soDetails?.salesOrderStageId == soStage.Shipped || soDetails?.salesOrderStageId == soStage.Labelling) && isVisibleCreateLabel && visibleFromModule == soChannel.SALES_ORDER && soDetails?.salesOrderStatusId != soStatus.Void" (click)="showShipmentDialog()">
                                            <i class="pi pi-briefcase"></i>
                                        </span>
                                    </ng-container>
                                </div>
                                <div style="display: flex; flex-direction: row; justify-content: flex-end; width: 30%">
                                    <span style="color: #ce1800" *ngIf="showOrderVoidMsg" pTooltip="on {{ voidDate }} <br/>by {{ app.user.userName }}" tooltipPosition="left" [escape]="false">
                                        Voided
                                    </span>
                                    @if(soDetails?.approvalStatusId && soDetails?.approvalStatusId > 0) {
                                        <p-button label="{{ soDetails?.approvalStatus ? soDetails?.approvalStatus : '' }}" 
                                        [text]="true" [raised]="true" severity="danger" class="large-font" (onClick)="showApprovalDetails(soDetails)" />
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="p-field p-formgrid p-grid">
            <div class="p-col" *ngIf="templates?.labels_section?.[0]?.isChecked">
                <div class="card">
                    <h6 class="p-mb-0">
                        {{ templates?.labels_section?.[0].labelname }}
                    </h6>
                    <p class="p-mb-0">
                        {{ soDetails?.paymentTerm?.name }}
                    </p>
                </div>
            </div>
            <div class="p-col" *ngIf="templates?.labels_section?.[1]?.isChecked">
                <div class="card">
                    <h6 class="p-mb-0">
                        {{ templates?.labels_section?.[1].labelname }}
                    </h6>
                    <p class="p-mb-0">
                        {{ soDetails?.paymentMethod?.name }}
                    </p>
                </div>
            </div>
            <div class="p-col" *ngIf="templates?.labels_section?.[2]?.isChecked">
                <div class="card">
                    <h6 class="p-mb-0">
                        {{ templates?.labels_section?.[2].labelname }}
                    </h6>
                    {{ soDetails?.shippingTerm?.name }}
                </div>
            </div>
            <div class="p-col" *ngIf="templates?.labels_section?.[3]?.isChecked">
                <div class="card">
                    <h6 class="p-mb-0">
                        {{ templates?.labels_section?.[3].labelname }}
                    </h6>
                    <p class="p-mb-0">
                        {{ soDetails?.shippingMethod?.name }}
                    </p>
                </div>
            </div>
            <div class="p-col" *ngIf="templates?.labels_section?.[4]?.isChecked">
                <div class="card">
                    <h6 class="p-mb-0">
                        {{ templates?.labels_section?.[4].labelname }}
                    </h6>
                    <p class="p-mb-0">
                        {{ soDetails?.user?.name }}
                    </p>
                </div>
            </div>
        
            <!-- custom section -->
            <app-custom-attribute-overview [fieldType]="fieldTypes.SECTION" [customFieldData]="customFields.section_item"> </app-custom-attribute-overview>
        </div>
        <div class="p-field p-formgrid p-grid">
            <div class="p-col-12">
                <p-table [value]="purchaseList" styleClass="p-datatable-gridlines p-datatable-striped" dataKey="id" class="custom-max-width">
                    <ng-template pTemplate="header">
                        <tr>
                            <th style="width: 3rem"></th>
                            <th *ngIf="templates?.labels_table?.[0]?.isChecked">
                                {{ templates?.labels_table?.[0]?.labelname }}
                            </th>
                            <th *ngIf="templates?.labels_table?.[18]?.isChecked">
                                {{ templates?.labels_table?.[18]?.labelname }}
                            </th>
                            <th *ngIf="templates?.labels_table?.[1]?.isChecked">
                                {{ templates?.labels_table?.[1]?.labelname }}
                            </th>
                            <th *ngIf="templates?.labels_table?.[11]?.isChecked">{{ templates?.labels_table?.[11]?.labelname }} </th>
                            <th *ngIf="soDetails?.salesOrderStageId != soStage.Shipped && templates?.labels_table?.[8]?.isChecked">
                                {{ templates?.labels_table?.[8]?.labelname }}
                            </th>
                            <th *ngIf="templates?.labels_table?.[2]?.isChecked">
                                {{ templates?.labels_table?.[2]?.labelname }}
                            </th>
                            <th *ngIf="templates?.labels_table?.[19]?.isChecked">
                                {{ templates?.labels_table?.[19]?.labelname }}
                            </th>
                            <th *ngIf="templates?.labels_table?.[20]?.isChecked">
                                {{ templates?.labels_table?.[20]?.labelname }}
                            </th>
                            <th *ngIf="templates?.labels_table?.[21]?.isChecked">
                                {{ templates?.labels_table?.[21]?.labelname }}
                            </th>
                            <th *ngIf="showPickColumn && templates?.labels_table?.[9]?.isChecked">
                                {{ templates?.labels_table?.[9]?.labelname }}
                            </th>
                            <th *ngIf="soDetails?.salesOrderStageId >= soStage.Pack && templates?.labels_table?.[10]?.isChecked">
                                {{ templates?.labels_table?.[10]?.labelname }}
                            </th>
                            <th *ngIf="soDetails?.salesOrderStageId == soStage.Shipped && templates?.labels_table?.[13]?.isChecked && isEnabledBackOrder">
                                {{ templates?.labels_table?.[13]?.labelname }}
                            </th>
                            <th *ngIf="soDetails?.salesOrderStageId == soStage.Shipped && templates?.labels_table?.[12]?.isChecked">
                                {{ templates?.labels_table?.[12]?.labelname }}
                            </th>
                            <th *ngIf="templates?.labels_table?.[3]?.isChecked">
                                {{ templates?.labels_table?.[3]?.labelname }}
                            </th>
                            <th *ngIf="templates?.labels_table?.[16]?.isChecked">
                                {{ templates?.labels_table?.[16]?.labelname }}
                            </th>
                            <th *ngIf="templates?.labels_table?.[17]?.isChecked">
                                {{ templates?.labels_table?.[17]?.labelname }}
                            </th>
                            <th *ngIf="templates?.labels_table?.[4]?.isChecked">
                                {{ templates?.labels_table?.[4]?.labelname }}
                            </th>
                            <th *ngIf="templates?.labels_table?.[14]?.isChecked">
                                {{ templates?.labels_table?.[14]?.labelname }}
                            </th>
                            <th *ngIf="templates?.labels_table?.[6]?.isChecked">
                                {{ templates?.labels_table?.[6]?.labelname }}
                            </th>
                            <th *ngIf="templates?.labels_table?.[5]?.isChecked">
                                {{ templates?.labels_table?.[5]?.labelname }}
                            </th>
                            <th *ngIf="templates?.labels_table?.[15]?.isChecked">
                                {{ templates?.labels_table?.[15]?.labelname }}
                            </th>
                            <th *ngIf="templates?.labels_table?.[7]?.isChecked">
                                {{ templates?.labels_table?.[7]?.labelname }}
                            </th>
                            <th style="width: 4rem" *ngIf="showPickColumn" class="action">
                                <span class="pi pi-check" style="color: var(--primary-color)"></span>
                            </th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-product let-index="rowIndex" let-expanded="expanded">
                        <tr [ngClass]="{ copiedProductRow: product?.isCopied }">
                            <td>
                                <button type="button" [pRowToggler]="product" pButton pRipple class="p-button-text p-button-rounded p-button-plain" [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'" *ngIf="product?.salesOrderBundleDetail?.length > 0" style="width: 1.25rem; height: 1.25rem"></button>
                            </td>
                            <td *ngIf="templates?.labels_table?.[0]?.isChecked" style="word-break: break-all">
                                <app-color-box [color]="product?.orderFulfillmentStatusColor"></app-color-box>
                                <p-cellEditor>
                                    <ng-template pTemplate="output">
                                        {{ product.itemNo ? product.itemNo : null }}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td *ngIf="templates?.labels_table?.[18]?.isChecked">
                                <p-cellEditor style="word-break: break-word; white-space: pre-line">
                                    <ng-template pTemplate="output">
                                        {{ product.hsnsac ? product.hsnsac : null }}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td *ngIf="templates?.labels_table?.[1]?.isChecked">
                                <p-cellEditor style="word-break: break-word; white-space: pre-line">
                                    <ng-template pTemplate="output">
                                        {{ product.description ? (product.description | shorten: 55) : null }}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td *ngIf="templates?.labels_table?.[11]?.isChecked">
                                <span *ngIf="product.typeId == 1">{{ product?.selectedBin?.binName }} ({{ product?.selectedBin?.availQty }})</span>
                            </td>
                            <td *ngIf="soDetails?.salesOrderStageId != soStage.Shipped && templates?.labels_table?.[8]?.isChecked">
                                {{product.availableQty ? (product.availableQty  | customNumberFormat: qtyFractionDigits) : null }}
        
                            </td>
                            <td *ngIf="templates?.labels_table?.[2]?.isChecked">
                                <p-cellEditor>
                                    <ng-template pTemplate="output">
                                        {{ product.qty ? (product.qty | customNumberFormat: qtyFractionDigits) : null }}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td *ngIf="templates?.labels_table?.[19]?.isChecked">
                                {{ product.serialNumber }}
                            </td>
                            <td *ngIf="templates?.labels_table?.[20]?.isChecked">
                                {{ product.lotNumber }}
                            </td>
                            <td *ngIf="templates?.labels_table?.[21]?.isChecked">
                                {{ product.revisionNumber }}
                            </td>
                            <td *ngIf="showPickColumn && templates?.labels_table?.[9]?.isChecked">
                                {{ product.pickedQty | customNumberFormat: qtyFractionDigits}}
                            </td>
                            <td *ngIf="soDetails?.salesOrderStageId >= soStage.Pack && templates?.labels_table?.[10]?.isChecked">
                                {{ product.packedQty | customNumberFormat: qtyFractionDigits}}
                            </td>
                            <td *ngIf="soDetails?.salesOrderStageId == soStage.Shipped && templates?.labels_table?.[13]?.isChecked && isEnabledBackOrder">
                                {{ product.backOrderQty | customNumberFormat: qtyFractionDigits}}
                            </td>
                            <td *ngIf="soDetails?.salesOrderStageId == soStage.Shipped && templates?.labels_table?.[12]?.isChecked">
                                {{ product.shippedQty | customNumberFormat: qtyFractionDigits}}
                            </td>
        
                            <td *ngIf="templates?.labels_table?.[3]?.isChecked">
                                <p-cellEditor>
                                    <ng-template pTemplate="output">
                                        {{ product.uom ? product.uom : null }}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td *ngIf="templates?.labels_table?.[16]?.isChecked">
                                <p-cellEditor>
                                    <ng-template pTemplate="output" *ngIf="product.typeId != 4">
                                        {{ product.costPrice | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : savedCurrencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td *ngIf="templates?.labels_table?.[17]?.isChecked">
                                <p-cellEditor>
                                    <ng-template pTemplate="output" *ngIf="product.typeId != 4">
                                        {{ product.totalCostPrice | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : savedCurrencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td *ngIf="templates?.labels_table?.[4]?.isChecked">
                                <p-cellEditor>
                                    <ng-template pTemplate="output" *ngIf="product.typeId != 4">
                                        {{ product.rate | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : savedCurrencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td *ngIf="templates?.labels_table?.[14]?.isChecked">
                                <p-cellEditor>
                                    <ng-template pTemplate="output">
                                        {{ product.subTotal | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : savedCurrencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td *ngIf="templates?.labels_table?.[6]?.isChecked">
                                <p-cellEditor>
                                    <ng-template pTemplate="output" *ngIf="product.typeId != 4">
                                        {{ product.discountAmount | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : savedCurrencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}
                                        <span *ngIf="product?.discountPercentage && product?.discountPercentage > 0"> ({{ product?.discountPercentage }}%) </span>
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td *ngIf="templates?.labels_table?.[5]?.isChecked">
                                <p-cellEditor>
                                    <ng-template pTemplate="output" *ngIf="product.typeId != 4">
                                        {{ product.taxAmount | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : savedCurrencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td *ngIf="templates?.labels_table?.[15]?.isChecked">
                                <p-cellEditor>
                                    <ng-template pTemplate="output" *ngIf="product.typeId != 4">
                                        {{ product.additionalAmount | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : savedCurrencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }} {{ product?.additionalFeesType == "Percentage" && product?.additionalRate && product?.additionalRate > 0 ? "(" + product?.additionalRate + ")%" : "" }}
        
                                        <!-- <span *ngIf="product?.additionalFeesType == 'Amount' && product?.additionalAmount && product?.additionalAmount > 0">
                                            {{ product.additionalAmount | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : savedCurrencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}
                                    </span>
                                    <span *ngIf="product?.additionalFeesType == 'Percentage' && product?.additionalRate && product?.additionalRate > 0"> 
                                        {{ product.additionalAmount | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : savedCurrencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}({{ product?.additionalRate }}%) 
                                    </span> -->
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td *ngIf="templates?.labels_table?.[7]?.isChecked">
                                <p-cellEditor>
                                    <ng-template pTemplate="output">
                                        {{ product.amount | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : savedCurrencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td *ngIf="showPickColumn" class="action"></td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="rowexpansion" let-product>
                        <ng-container *ngFor="let bundleProduct of product?.salesOrderBundleDetail">
                            <!-- bundle items -->
                            <tr class="bundleRow">
                                <td class="action">
                                    <button type="button" pButton pRipple *ngIf="bundleProduct?.salesOrderBundleDetail?.length > 0" (click)="bundleProduct.show = !bundleProduct.show" class="p-button-text p-button-rounded p-button-plain p-ml-2" [icon]="bundleProduct.show ? 'pi pi-chevron-down' : 'pi pi-chevron-right'" style="width: 1.25rem; height: 1.25rem"> </button>
                                </td>
                                <td *ngIf="templates?.labels_table?.[0]?.isChecked" style="padding-left: 1.5rem !important; word-break: break-all">
                                    <app-color-box [color]="bundleProduct?.orderFulfillmentStatusColor"></app-color-box>
                                    <p-cellEditor>
                                        <ng-template pTemplate="output">
                                            {{ bundleProduct?.itemNo ? bundleProduct?.itemNo : null }}
                                        </ng-template>
                                    </p-cellEditor>
                                </td>
                                <td *ngIf="templates?.labels_table?.[18]?.isChecked">
                                    <p-cellEditor style="word-break: break-word; white-space: pre-line">
                                        <ng-template pTemplate="output">
                                            {{ bundleProduct?.hsnsac ? (bundleProduct?.hsnsac) : null }}
                                        </ng-template>
                                    </p-cellEditor>
                                </td>
                                <td *ngIf="templates?.labels_table?.[1]?.isChecked">
                                    <p-cellEditor style="word-break: break-word; white-space: pre-line">
                                        <ng-template pTemplate="output">
                                            {{ bundleProduct?.description ? (bundleProduct?.description | shorten: 55) : null }}
                                        </ng-template>
                                    </p-cellEditor>
                                </td>
                                <td *ngIf="templates?.labels_table?.[11]?.isChecked"
                                    ><span *ngIf="bundleProduct?.typeId == 1">{{ bundleProduct?.selectedBin?.binName }} ({{ bundleProduct?.selectedBin?.availQty }})</span></td
                                >
                                <td *ngIf="soDetails?.salesOrderStageId != soStage.Shipped && templates?.labels_table?.[8]?.isChecked">
                                {{bundleProduct.availableQty ? (bundleProduct.availableQty  | customNumberFormat: qtyFractionDigits) : null }}
        
                                </td>
                                <td *ngIf="templates?.labels_table?.[2]?.isChecked">
                                    <p-cellEditor>
                                        <ng-template pTemplate="output">
                                            {{ bundleProduct?.qty | customNumberFormat: qtyFractionDigits }}
                                        </ng-template>
                                    </p-cellEditor>
                                </td>
                                <td *ngIf="templates?.labels_table?.[19]?.isChecked">
                                    {{ bundleProduct.serialNumber }}
                                </td>
                                <td *ngIf="templates?.labels_table?.[20]?.isChecked">
                                    {{ bundleProduct.lotNumber }}
                                </td>
                                <td *ngIf="templates?.labels_table?.[21]?.isChecked">
                                    {{ bundleProduct.revisionNumber }}
                                </td>
                                <td *ngIf="showPickColumn && templates?.labels_table?.[9]?.isChecked">
                                    {{ bundleProduct?.pickedQty | customNumberFormat: qtyFractionDigits}}
                                </td>
                                <td *ngIf="soDetails?.salesOrderStageId >= soStage.Pack && templates?.labels_table?.[10]?.isChecked">
                                    {{ bundleProduct.packedQty | customNumberFormat: qtyFractionDigits}}
                                </td>
                                <td *ngIf="soDetails?.salesOrderStageId == soStage.Shipped && templates?.labels_table?.[13]?.isChecked && isEnabledBackOrder">
                                    {{ bundleProduct.backOrderQty | customNumberFormat: qtyFractionDigits}}
                                </td>
                                <td *ngIf="soDetails?.salesOrderStageId == soStage.Shipped && templates?.labels_table?.[12]?.isChecked">
                                    {{ bundleProduct.shippedQty | customNumberFormat: qtyFractionDigits}}
                                </td>
        
                                <td *ngIf="templates?.labels_table?.[3]?.isChecked">
                                    <p-cellEditor>
                                        <ng-template pTemplate="output">
                                            {{ bundleProduct?.uom ? bundleProduct?.uom : null }}
                                        </ng-template>
                                    </p-cellEditor>
                                </td>
                                <td *ngIf="templates?.labels_table?.[16]?.isChecked">
                                    <p-cellEditor *ngIf="product.typeId != 6">
                                        <ng-template pTemplate="output">
                                            {{ bundleProduct?.costPrice | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : savedCurrencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}
                                        </ng-template>
                                    </p-cellEditor>
                                </td>
                                <td *ngIf="templates?.labels_table?.[17]?.isChecked">
                                    <p-cellEditor *ngIf="product.typeId != 6">
                                        <ng-template pTemplate="output">
                                            {{ bundleProduct?.totalCostPrice | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : savedCurrencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}
                                        </ng-template>
                                    </p-cellEditor>
                                </td>
                                <td *ngIf="templates?.labels_table?.[4]?.isChecked">
                                    <p-cellEditor *ngIf="product.typeId != 6">
                                        <ng-template pTemplate="output">
                                            {{ bundleProduct?.rate | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : savedCurrencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}
                                        </ng-template>
                                    </p-cellEditor>
                                </td>
                                <td *ngIf="templates?.labels_table?.[14]?.isChecked">
                                    <p-cellEditor *ngIf="product.typeId != 6">
                                        <ng-template pTemplate="output">
                                            {{ bundleProduct?.subTotal | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : savedCurrencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}
                                        </ng-template>
                                    </p-cellEditor>
                                </td>
                                <td *ngIf="templates?.labels_table?.[6]?.isChecked">
                                    <p-cellEditor *ngIf="product.typeId != 6">
                                        <ng-template pTemplate="output">
                                            {{ bundleProduct?.discountAmount | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : savedCurrencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}
                                            <span *ngIf="bundleProduct?.discountPercentage && bundleProduct?.discountPercentage > 0"> ({{ bundleProduct?.discountPercentage }}%) </span>
                                        </ng-template>
                                    </p-cellEditor>
                                </td>
                                <td *ngIf="templates?.labels_table?.[5]?.isChecked">
                                    <p-cellEditor *ngIf="product.typeId != 6">
                                        <ng-template pTemplate="output">
                                            {{ bundleProduct?.taxAmount | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : savedCurrencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}
                                        </ng-template>
                                    </p-cellEditor>
                                </td>
                                <td *ngIf="templates?.labels_table?.[15]?.isChecked">
                                    <p-cellEditor *ngIf="product.typeId != 6">
                                        <ng-template pTemplate="output"> {{ bundleProduct?.additionalAmount | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : savedCurrencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }} {{ bundleProduct?.additionalFeesType == "Percentage" && bundleProduct?.additionalRate && bundleProduct?.additionalRate > 0 ? "(" + bundleProduct?.additionalRate + ")%" : "" }} </ng-template>
                                    </p-cellEditor>
                                </td>
                                <td *ngIf="templates?.labels_table?.[7]?.isChecked">
                                    <p-cellEditor *ngIf="product.typeId != 6">
                                        <ng-template pTemplate="output">
                                            {{ bundleProduct.amount | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : savedCurrencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}
                                        </ng-template>
                                    </p-cellEditor>
                                </td>
                                <td *ngIf="showPickColumn" class="action"></td>
                            </tr>
                            <ng-container *ngIf="bundleProduct.show">
                                <!-- kit under kit items -->
                                <tr *ngFor="let kp of bundleProduct?.salesOrderBundleDetail" class="bundleRowSub">
                                    <td></td>
                                    <td *ngIf="templates?.labels_table?.[0]?.isChecked" style="padding-left: 2rem !important; word-break: break-all">
                                        <app-color-box [color]="kp?.orderFulfillmentStatusColor"></app-color-box>
                                        <p-cellEditor>
                                            <ng-template pTemplate="output">
                                                {{ kp?.itemNo ? kp?.itemNo : null }}
                                            </ng-template>
                                        </p-cellEditor>
                                    </td>
                                    <td *ngIf="templates?.labels_table?.[18]?.isChecked">
                                        <p-cellEditor style="word-break: break-word; white-space: pre-line">
                                            <ng-template pTemplate="output">
                                                {{ kp?.hsnsac ? kp?.hsnsac: null }}
                                            </ng-template>
                                        </p-cellEditor>
                                    </td>
                                    <td *ngIf="templates?.labels_table?.[1]?.isChecked">
                                        <p-cellEditor style="word-break: break-word; white-space: pre-line">
                                            <ng-template pTemplate="output">
                                                {{ kp?.description ? (kp?.description | shorten: 55) : null }}
                                            </ng-template>
                                        </p-cellEditor>
                                    </td>
                                    <td *ngIf="templates?.labels_table?.[11]?.isChecked"
                                        ><span *ngIf="kp?.typeId == 1">{{ kp?.selectedBin?.binName }} ({{ kp?.selectedBin?.availQty }})</span></td
                                    >
                                    <td *ngIf="soDetails?.salesOrderStageId != soStage.Shipped && templates?.labels_table?.[8]?.isChecked">
                                {{kp.availableQty ? (kp.availableQty  | customNumberFormat: qtyFractionDigits) : null }}
        
                                    </td>
                                    <td *ngIf="templates?.labels_table?.[2]?.isChecked">
                                        <p-cellEditor>
                                            <ng-template pTemplate="output">
                                                {{ kp?.qty | customNumberFormat: qtyFractionDigits }}
                                            </ng-template>
                                        </p-cellEditor>
                                    </td>
                                    <td *ngIf="templates?.labels_table?.[19]?.isChecked">
                                        {{ kp.serialNumber }}
                                    </td>
                                    <td *ngIf="templates?.labels_table?.[20]?.isChecked">
                                        {{ kp.lotNumber }}
                                    </td>
                                    <td *ngIf="templates?.labels_table?.[21]?.isChecked">
                                        {{ kp.revisionNumber }}
                                    </td>
                                    <td *ngIf="showPickColumn && templates?.labels_table?.[9]?.isChecked">
                                        {{ kp?.pickedQty | customNumberFormat: qtyFractionDigits}}
                                    </td>
                                    <td *ngIf="soDetails?.salesOrderStageId >= soStage.Pack && templates?.labels_table?.[10]?.isChecked">
                                        {{ kp.packedQty | customNumberFormat: qtyFractionDigits}}
                                    </td>
                                    <td *ngIf="soDetails?.salesOrderStageId == soStage.Shipped && templates?.labels_table?.[13]?.isChecked && isEnabledBackOrder">
                                        {{ kp.backOrderQty | customNumberFormat: qtyFractionDigits}}
                                    </td>
                                    <td *ngIf="soDetails?.salesOrderStageId == soStage.Shipped && templates?.labels_table?.[12]?.isChecked">
                                        {{ kp.shippedQty | customNumberFormat: qtyFractionDigits}}
                                    </td>
        
                                    <td *ngIf="templates?.labels_table?.[3]?.isChecked">
                                        <p-cellEditor>
                                            <ng-template pTemplate="output">
                                                {{ kp?.uom ? kp?.uom : null }}
                                            </ng-template>
                                        </p-cellEditor>
                                    </td>
                                    <td *ngIf="templates?.labels_table?.[16]?.isChecked"> </td>
                                    <td *ngIf="templates?.labels_table?.[17]?.isChecked"> </td>
                                    <td *ngIf="templates?.labels_table?.[4]?.isChecked"> </td>
                                    <td *ngIf="templates?.labels_table?.[14]?.isChecked"> </td>
                                    <td *ngIf="templates?.labels_table?.[5]?.isChecked"> </td>
                                    <td *ngIf="templates?.labels_table?.[6]?.isChecked"> </td>
                                    <td *ngIf="templates?.labels_table?.[7]?.isChecked"> </td>
                                    <td *ngIf="showPickColumn" class="action"></td>
                                </tr>
                            </ng-container>
                        </ng-container>
                    </ng-template>
                    <ng-template pTemplate="footer">
                        <tr>
                            <td></td>
                            <td class="p-text-left">{{ templates?.labels_footer[0]?.labelname }}</td>
                            <td class="p-text-left"></td>
                            <td *ngIf="templates?.labels_table[11]?.isChecked"></td>
                            <td *ngIf="soDetails?.salesOrderStageId != soStage.Shipped && templates?.labels_table?.[8]?.isChecked"></td>
                            <td *ngIf="templates?.labels_table[2]?.isChecked"></td>
                            <td *ngIf="templates?.labels_table[18]?.isChecked"></td>
                            <td *ngIf="templates?.labels_table[19]?.isChecked"></td>
                            <td *ngIf="templates?.labels_table[20]?.isChecked"></td>
                            <td *ngIf="templates?.labels_table[21]?.isChecked"></td>
                            <td *ngIf="showPickColumn && templates?.labels_table[9]?.isChecked"></td>
                            <td *ngIf="soDetails?.salesOrderStageId >= soStage.Pack && templates?.labels_table?.[10]?.isChecked"></td>
                            <td *ngIf="soDetails?.salesOrderStageId == soStage.Shipped && templates?.labels_table?.[13]?.isChecked && isEnabledBackOrder"></td>
                            <td *ngIf="soDetails?.salesOrderStageId == soStage.Shipped && templates?.labels_table?.[12]?.isChecked"></td>
                            <td *ngIf="templates?.labels_table?.[3]?.isChecked"></td>
                            <td *ngIf="templates?.labels_table?.[16]?.isChecked"></td>
                            <td *ngIf="templates?.labels_table?.[17]?.isChecked"></td>
                            <td *ngIf="templates?.labels_table?.[4]?.isChecked"></td>
                            <td *ngIf="templates?.labels_table[14]?.isChecked">{{ soDetails?.totalAmount | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : savedCurrencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}</td>
                            <td *ngIf="templates?.labels_table[6]?.isChecked">{{ soDetails?.discountAmount | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : savedCurrencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}</td>
                            <td *ngIf="templates?.labels_table[5]?.isChecked">{{ soDetails?.taxAmount | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : savedCurrencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}</td>
                            <td *ngIf="templates?.labels_table[15]?.isChecked">{{ productsTotalAdditionalAmount | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : savedCurrencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}</td>
                            <td *ngIf="templates?.labels_table[7]?.isChecked">{{ totalAmount | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : savedCurrencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}</td>
                            <td *ngIf="showPickColumn" class="action"></td>
                        </tr>
                        <tr *ngIf="templates?.labels_footer?.[0]?.isChecked && !templates?.labels_table[14]?.isChecked">
                            <td colspan="3" class="p-text-left">
                                <!-- Custom -->
                                <app-custom-attribute-overview *ngIf="customFields?.footer_item && customFields.footer_item[0]" [fieldType]="fieldTypes.FOOTER" [customFieldData]="customFields.footer_item[0]"> </app-custom-attribute-overview>
                            </td>
                            <td [attr.colspan]="cols - 3" class="p-text-right">
                                {{ templates?.labels_footer?.[0]?.labelname }}
                            </td>
                            <td [attr.colspan]="footerValueColSpan">
                                {{ soDetails?.totalAmount | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : savedCurrencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}
                            </td>
                        </tr>
                        <tr *ngIf="templates?.labels_footer?.[1]?.isChecked && !templates?.labels_table[6]?.isChecked">
                            <td colspan="3" class="p-text-left">
                                <!-- Custom -->
                                <app-custom-attribute-overview *ngIf="customFields?.footer_item && customFields.footer_item[1]" [fieldType]="fieldTypes.FOOTER" [customFieldData]="customFields.footer_item[1]"> </app-custom-attribute-overview>
                            </td>
                            <td [attr.colspan]="cols - 3" class="p-text-right">
                                {{ templates?.labels_footer?.[1]?.labelname }}
                            </td>
                            <td [attr.colspan]="footerValueColSpan">
                                {{ soDetails?.discountAmount | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : savedCurrencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}
                            </td>
                        </tr>
                        <tr *ngIf="templates?.labels_footer?.[2]?.isChecked && !templates?.labels_table[5]?.isChecked">
                            <td colspan="3" class="p-text-left">
                                <!-- Custom -->
                                <app-custom-attribute-overview *ngIf="customFields?.footer_item && customFields.footer_item[2]" [fieldType]="fieldTypes.FOOTER" [customFieldData]="customFields.footer_item[2]"> </app-custom-attribute-overview>
                            </td>
                            <td [attr.colspan]="cols - 3" class="p-text-right">
                                {{ templates?.labels_footer?.[2]?.labelname }}
                            </td>
                            <td [attr.colspan]="footerValueColSpan">
                                {{ soDetails?.taxAmount | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : savedCurrencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}
                            </td>
                        </tr>
                        <tr *ngIf="templates?.labels_footer?.[10]?.isChecked">
                            <td colspan="3" class="p-text-left">
                                <!-- Custom -->
                                <app-custom-attribute-overview *ngIf="customFields?.footer_item && customFields.footer_item[2]" [fieldType]="fieldTypes.FOOTER" [customFieldData]="customFields.footer_item[2]"> </app-custom-attribute-overview>
                            </td>
                            <td [attr.colspan]="cols - 3" class="p-text-right">
                                {{ templates?.labels_footer?.[10]?.labelname }}
                            </td>
                            <td [attr.colspan]="footerValueColSpan">
                                {{ soDetails?.additionalAmount | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : savedCurrencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}
                            </td>
                        </tr>
                        <tr *ngIf="templates?.labels_footer?.[9]?.isChecked">
                            <td colspan="3" class="p-text-left">
                                <!-- Custom -->
                                <app-custom-attribute-overview *ngIf="customFields?.footer_item && customFields.footer_item[9]" [fieldType]="fieldTypes.FOOTER" [customFieldData]="customFields.footer_item[9]"> </app-custom-attribute-overview>
                            </td>
                            <td [attr.colspan]="cols - 3" class="p-text-right">
                                {{ templates?.labels_footer?.[9]?.labelname }}
                            </td>
                            <td [attr.colspan]="footerValueColSpan">
                                {{ soDetails?.additionalDiscount | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : savedCurrencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}
                            </td>
                        </tr>
                        <tr *ngIf="templates?.labels_footer?.[3]?.isChecked">
                            <td colspan="3" class="p-text-left">
                                <!-- Custom -->
                                <app-custom-attribute-overview *ngIf="customFields?.footer_item && customFields.footer_item[3]" [fieldType]="fieldTypes.FOOTER" [customFieldData]="customFields.footer_item[3]"> </app-custom-attribute-overview>
                            </td>
                            <td [attr.colspan]="cols - 3" class="p-text-right">
                                {{ templates?.labels_footer?.[3]?.labelname }}
                            </td>
                            <td [attr.colspan]="footerValueColSpan">
                                {{ soDetails?.shippingChargeAmount | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : savedCurrencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}
                            </td>
                        </tr>
                        <tr *ngIf="templates?.labels_footer?.[5]?.isChecked && soDetails?.isFreeShipping">
                            <td colspan="3" class="p-text-left">
                                <!-- Custom -->
                                <app-custom-attribute-overview *ngIf="customFields?.footer_item && customFields.footer_item[5]" [fieldType]="fieldTypes.FOOTER" [customFieldData]="customFields.footer_item[5]"> </app-custom-attribute-overview>
                            </td>
                            <td [attr.colspan]="cols - 3" class="p-text-right">
                                {{ templates?.labels_footer?.[5]?.labelname }}
                            </td>
                            <td [attr.colspan]="footerValueColSpan">
                                {{ soDetails?.shippingChargeAmount | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : savedCurrencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}
                            </td>
                        </tr>
                        <tr *ngIf="templates?.labels_footer?.[4]?.isChecked">
                            <td colspan="3" class="p-text-left">
                                <!-- Custom -->
                                <app-custom-attribute-overview *ngIf="customFields?.footer_item && customFields.footer_item[4]" [fieldType]="fieldTypes.FOOTER" [customFieldData]="customFields.footer_item[4]"> </app-custom-attribute-overview>
                            </td>
                            <td [attr.colspan]="cols - 3" class="p-text-right">
                                {{ templates?.labels_footer?.[4]?.labelname }}
                            </td>
                            <td [attr.colspan]="footerValueColSpan">
                                {{ soDetails?.netAmount | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : savedCurrencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}
                            </td>
                        </tr>
                        <tr *ngIf="templates?.labels_footer?.[6]?.isChecked && soDetails?.appliedAmount > 0">
                            <td colspan="3" class="p-text-left">
                                <!-- Custom -->
                                <app-custom-attribute-overview *ngIf="customFields?.footer_item && customFields.footer_item[6]" [fieldType]="fieldTypes.FOOTER" [customFieldData]="customFields.footer_item[6]"> </app-custom-attribute-overview>
                            </td>
                            <td [attr.colspan]="cols - 3" class="p-text-right">
                                {{ templates?.labels_footer?.[6]?.labelname }}
                            </td>
                            <td [attr.colspan]="footerValueColSpan">
                                <span class="p-mb-0 acc-name-popup-link" (click)="onAppliedAmountViewClick(soDetails)">
                                    {{ soDetails?.appliedAmount | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : savedCurrencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}
                                </span>
                            </td>
                        </tr>
                        <tr *ngIf="templates?.labels_footer?.[7]?.isChecked">
                            <td colspan="3" class="p-text-left">
                                <!-- Custom -->
                                <app-custom-attribute-overview *ngIf="customFields?.footer_item && customFields.footer_item[7]" [fieldType]="fieldTypes.FOOTER" [customFieldData]="customFields.footer_item[7]"> </app-custom-attribute-overview>
                            </td>
                            <td [attr.colspan]="cols - 3" class="p-text-right">
                                {{ templates?.labels_footer?.[7]?.labelname }}
                            </td>
                            <td [attr.colspan]="footerValueColSpan">
                                {{ soDetails?.balanceDue | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : savedCurrencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
        
        <div class="p-mb-3 card" *ngIf="soDetails?.salesOrderStageId != soStage.Shipped">
            <div class="p-d-flex">
                <h6 class="p-mb-0 p-mt-2 p-mr-2">Credit Memos:</h6>
                <div class="p-inputgroup" style="width: auto">
                    <div *ngIf="creditAppliedTotal > 0">
                        <p-inputNumber mode="decimal" inputId="withoutgrouping" [useGrouping]="false" class="small inlineDD" disabled [(ngModel)]="creditAppliedTotal" [ngModelOptions]="{ standalone: true }"> </p-inputNumber>
                    </div>
                    <div *ngIf="creditAppliedTotal <= 0">
                        <p-inputNumber mode="decimal" inputId="withoutgrouping" [useGrouping]="false" class="small inlineDD" disabled [(ngModel)]="totalCreditAmount" [ngModelOptions]="{ standalone: true }"> </p-inputNumber>
                    </div>
                    <button type="button" pButton pRipple label="View" (click)="displayCreditMemoSelectionModal()"> </button>
                </div>
            </div>
        </div>
        <br />
        
        <!-- Tax Based Products list -->
        <!-- <p-table [columns]="taxBasedProductsCols" [value]="taxBasedProductsList">
            <ng-template pTemplate="header" let-columns>
                <tr>
                    <th *ngFor="let col of columns">
                        {{col}}
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-product let-columns="columns">
                <tr>
                    <td *ngFor="let col of columns">
                        {{ col == 'HSN Codes' ? product['itemNo'] : col == 'Taxable Amount' ? (product['taxRate'] | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : savedCurrencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits) : (product[col] | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : savedCurrencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits) }}
                    </td>
                </tr>
            </ng-template>
        </p-table> -->
        
        <div *ngIf="showTaxBasedSplitView">
            <app-products-tax-split-view [products]="purchaseList" [isStateMatched]="isStateMatched" [savedCurrencyExchangeRate]="savedCurrencyExchangeRate" 
                [savedCurrencyUnit]="savedCurrencyUnit" [channel]="soChannel.SALES_ORDER">
            </app-products-tax-split-view>
        </div>
        <br/><br/>
        
        <div class="p-col-12 p-md-12" *ngIf="templates?.labels_message && templates?.labels_message?.length > 1">
            <div class="p-fluid">
                <div class="card" style="min-height: 100px">
                    <p class="p-mb-0" *ngIf="templates?.labels_message[0]?.isChecked">
                        <b>{{ templates?.labels_message[0]?.labelname }}:</b>
                        <span>{{ soDetails?.salesOrderAudit && soDetails?.salesOrderAudit?.length > 0 ? soDetails?.salesOrderAudit[soDetails?.salesOrderAudit?.length - 1]?.note?.comment : "" }}</span>
                    </p>
        
                    <p class="p-mb-0" *ngIf="templates?.labels_message[1]?.isChecked">
                        <!-- <b>{{ templates?.labels_message[1]?.labelname }}:</b>
                        <span>{{
                            soDetails?.salesOrderNote &&
                            soDetails?.salesOrderNote?.length > 0
                            ? soDetails?.salesOrderNote[
                            soDetails?.salesOrderNote?.length - 1
                            ]?.note?.comment
                            : ""
                            }}</span> -->
        
                        <span>
                            <b style="display: inline">{{ templates?.labels_message[1]?.labelname }}:</b>
                            <span style="display: inline; white-space: normal; max-width: 100%" *ngIf="soDetails?.salesOrderNote && soDetails?.salesOrderNote?.length > 0">
                                <span [innerHTML]="getSanitizedHtml(soDetails?.salesOrderNote[soDetails?.salesOrderNote?.length - 1]?.note?.comment)"></span>
                            </span>
                        </span>
                    </p>
                    <br />
        
                    <!--Shipment Information-->
                    <div *ngIf="templates?.labels_message[2]?.isChecked">
                        <div *ngFor="let d of soDetails?.shipment">
                            <!-- Tracking No (Easypost,Ups,Fedex)-->
                            <div class="p-col-12 p-md-12" *ngIf="d?.statusId != '3' && d?.trackingLink != 'FEDEX' && d?.trackingLink != 'UPS'">
                                <span
                                    >Tracking No : {{ d?.trackingNo }}
                                    <span class="btnBars p-mr-0" *ngIf="(d?.deliveryStatus == 'pre_transit' || d?.deliveryStatus == '') && d?.statusId == '1'">
                                        <i class="pi pi-times-circle" [pTooltip]="'Void Shipment'" (click)="voidShipment(d)" *ngIf="visibleFromModule == soChannel.SALES_ORDER"></i>
                                    </span>
                                </span>
                            </div>
                            <div class="p-col-12 p-md-12" *ngIf="d?.statusId != '3' && d?.trackingLink == 'UPS'">
                                <span
                                    >Tracking No : {{ d?.trackingNo }}
                                    <span class="btnBars p-mr-0" *ngIf="d?.statusId == '1'">
                                        <i class="pi pi-times-circle" [pTooltip]="'Void Shipment'" (click)="voidShipment(d)" *ngIf="visibleFromModule == soChannel.SALES_ORDER"></i>
                                    </span>
                                </span>
                            </div>
                            <div class="p-col-12 p-md-12" *ngIf="d?.statusId != '3' && d?.trackingLink == 'FEDEX'">
                                <span
                                    >Tracking No : {{ d?.trackingNo }}
                                    <span class="btnBars p-mr-0" *ngIf="d?.statusId == '1'">
                                        <i class="pi pi-times-circle" [pTooltip]="'Void Shipment'" (click)="voidShipment(d)" *ngIf="visibleFromModule == soChannel.SALES_ORDER"></i>
                                    </span>
                                </span>
                            </div>
        
                            <!--Other Information-->
                            <div class="p-col-12 p-md-12" *ngIf="d?.statusId == '2'"
                                ><span>{{ d?.refundStatus }}</span></div
                            >
                            <div class="p-col-12 p-md-12" *ngIf="d?.statusId != '2' && d?.trackingLink != 'FEDEX' && d?.trackingLink != 'UPS'">
                                <span>Delivery Status :{{ d?.statusId == "3" ? "Voided" : d?.shipmentMessage }}</span>
                            </div>
                            <div class="p-col-12 p-md-12" *ngIf="d?.statusId == '3'"
                                ><span>Refund Status : {{ d?.refundStatus }}</span></div
                            >
                            <div class="p-col-12 p-md-12" *ngIf="d?.trackingLink && d?.trackingLink != 'FEDEX' && d?.trackingLink != 'UPS' && d?.statusId == '1' && d?.deliveryStatus != 'delivered'">
                                <span> <a href="{{ d?.trackingLink }}" target="_blank" *ngIf="visibleFromModule == soChannel.SALES_ORDER">Track order</a></span>
                            </div>
                            <div class="p-col-12 p-md-12" *ngIf="d?.trackingLink && d?.trackingLink == 'FEDEX' && d?.statusId == '1'"
                                ><span>
                                    <p>Delivery Status : {{ d?.deliveryStatus ?? "" }}</p>
                                    <button type="button" pButton (click)="trackFedexShipment(d?.trackingNo)" *ngIf="visibleFromModule == soChannel.SALES_ORDER" label="Track Order" style="width: 100px"></button> </span
                            ></div>
                            <div class="p-col-12 p-md-12" *ngIf="d?.trackingLink && d?.trackingLink == 'UPS' && d?.statusId == '3'"
                                ><span>
                                    <p>Delivery Status : Voided</p>
                                </span></div
                            >
                            <div *ngIf="d?.statusId == '1' && d?.deliveryStatus != 'delivered'" class="p-col-12 p-md-12 pointer" (click)="viewLabelPdf(d)">
                                <p>View Label</p>
                            </div>
                            <div class="p-col-12 p-md-12" *ngIf="d?.trackingLink && d?.trackingLink == 'UPS' && d?.statusId == '1'"
                                ><span>
                                    <p>Delivery Status : {{ shipMessage }}</p>
                                    <button type="button" pButton (click)="trackUpsShipment(d?.trackingNo)" label="Track Order" *ngIf="visibleFromModule == soChannel.SALES_ORDER" style="width: 100px"></button> </span
                            ></div>
                            <br />
                        </div>
                        <br />
                    </div>
        
                    <!-- custom -->
                    <app-custom-attribute-overview [fieldType]="fieldTypes.FIELD" [customFieldData]="customFields.message_item"> </app-custom-attribute-overview>
                </div>
            </div>
        </div>
        
        <!--Custom section and fields-->
        <div class="p-col-12 p-md-12" *ngIf="customFields?.other1_item && customFields?.other1_item?.length > 0">
            <div class="p-fluid">
                <div class="card" style="min-height: 150px">
                    <!-- custom -->
                    <h6 class="p-mb-0">{{ getFilteredSectionsByType("labels_estimate_other1") }}</h6>
                    <app-custom-attribute-overview [fieldType]="fieldTypes.FIELD" [customFieldData]="customFields.other1_item"> </app-custom-attribute-overview>
                </div>
            </div>
        </div>
        
        <div class="p-col-12 p-md-12" *ngIf="customFields?.other2_item && customFields?.other2_item?.length > 0">
            <div class="p-fluid">
                <div class="card" style="min-height: 150px">
                    <!-- custom -->
                    <h6 class="p-mb-0">{{ getFilteredSectionsByType("labels_estimate_other2") }}</h6>
                    <app-custom-attribute-overview [fieldType]="fieldTypes.FIELD" [customFieldData]="customFields.other2_item"> </app-custom-attribute-overview>
                </div>
            </div>
        </div>
        
        <div class="p-col-12 p-md-12" *ngIf="customFields?.other3_item && customFields?.other3_item?.length > 0">
            <div class="p-fluid">
                <div class="card" style="min-height: 150px">
                    <!-- custom -->
                    <h6 class="p-mb-0">{{ getFilteredSectionsByType("labels_estimate_other3") }}</h6>
                    <app-custom-attribute-overview [fieldType]="fieldTypes.FIELD" [customFieldData]="customFields.other3_item"> </app-custom-attribute-overview>
                </div>
            </div>
        </div>
        
        <div class="p-col-12 p-md-12" *ngIf="templates?.labels_message[5]?.isChecked">
            <app-tracking-details-view [trackingDetails]="trackingDetails" [notMatchedTracking]="notMatchedTrackingDetails"></app-tracking-details-view>
        </div>
        
        <p-dialog header="Payment History" [(visible)]="displayInvoiceHistory" [style]="{ width: '35vw' }">
            <div class="card">
                <ng-container *ngFor="let s of invoiceHisotry">
                    <div class="p-grid">
                        <div class="p-col-3">
                            <small>
                                <p>{{ s.date }}</p>
                            </small>
                        </div>
                        <div class="p-col-7">
                            <h6>{{ s.message }}</h6>
                        </div>
                        <div class="p-col-2">
                            <small
                                ><i>by {{ s.user }}</i></small
                            >
                        </div>
                    </div>
                </ng-container>
            </div>
            <ng-template pTemplate="footer">
                <p-button (click)="displayInvoiceHistory = false" label="Cancel" styleClass="p-button-secondary"></p-button>
            </ng-template>
        </p-dialog>
        
        <!--Shipment dialog-->
        <!-- <p-dialog [(visible)]="displayShipmentDialog" [style]="{ width: '60vw' }" (onHide)="onShipmentDialogClose()"
            [blockScroll]="true">
            <ng-container *ngIf="isVisibleCarrier">
                <div class="header">
                    <div class="p-grid">
                        <div class="p-col-12 p-md-6 p-pb-0">
                            <p-dropdown [options]="shippingCarriers" appendTo="body" optionLabel="name" dataKey="id"
                                [(ngModel)]="selectedCarrier" [ngModelOptions]="{ standalone: true }"
                                (onChange)="onChangeCarrier()"> </p-dropdown>
                        </div>
                    </div>
                </div>
                <h4 class="p-text-center p-my-3">{{ selectedCarrier?.name }}</h4>
            </ng-container>
            <div *ngIf="selectedCarrier && selectedCarrier.name && selectedCarrier.name.toLowerCase() == 'easypost'">
                <app-easypost-shipment [displayAddPackage]="displayShipmentDialog" [detailsObj]="soDetails"
                    [selectedCarrier]="selectedCarrier" [channel]="channel" (onLabelCreate)="createLabel($event)"
                    (onClose)="onShipmentDialogClose()" (onStepChange)="onStepChange($event)"></app-easypost-shipment>
            </div>
            <div *ngIf="selectedCarrier && selectedCarrier.name && selectedCarrier.name.toLowerCase() == 'fedex'">
                <app-fedex-shipment [detailsObj]="soDetails" [channel]="channel" [vendorFedexInfo]="vendorFedexInfo"
                    [selectedCarrier]="selectedCarrier" [fedexAccountInfo]="fedexAccountInfo"
                    [allFedexAccounts]="allFedexAccounts" [allShippingMethods]="allShippingMethods"
                    [displayAddPackage]="displayShipmentDialog" (onFedexLabelCreate)="createFedexLabel($event)"
                    (onClose)="onShipmentDialogClose()" (onStepChange)="onStepChange($event)"></app-fedex-shipment>
            </div>
            <div *ngIf="selectedCarrier && selectedCarrier.name && selectedCarrier.name.toLowerCase() == 'ups'">
                <app-ups-shipment [detailsObj]="soDetails" [channel]="channel" [vendorUpsInfo]="vendorUpsInfo"
                    [selectedCarrier]="selectedCarrier" [fedexAccountInfo]="fedexAccountInfo" [allUpsAccounts]="allUpsAccounts"
                    [allShippingMethods]="allShippingMethods" [displayAddPackage]="displayShipmentDialog"
                    (onSuccessfullUpsShipment)="onSuccessfullUpsShipment($event)" (onClose)="onShipmentDialogClose()"
                    (onStepChange)="onStepChange($event)"></app-ups-shipment>
            </div>
        </p-dialog> -->
        <!--Shipment dialog-->
        <p-dialog [(visible)]="displayShipmentDialog" [style]="{ width: '70vw' }" (onHide)="onShipmentDialogClose()" [blockScroll]="true" [closable]="false">
            <ng-template pTemplate="header">
                <ng-container *ngIf="isVisibleCarrier">
                    <div class="header p-grid w-100">
                        <div class="p-col-4">
                            <p-dropdown [options]="shippingCarriers" appendTo="body" optionLabel="name" dataKey="id" [(ngModel)]="selectedCarrier" [ngModelOptions]="{ standalone: true }" (onChange)="onChangeCarrier()"> </p-dropdown>
                        </div>
                        <div class="p-col-4">
                            <ng-container *ngIf="selectedCarrier && selectedCarrier.name && selectedCarrier.name.toLowerCase() == 'fedex'">
                                <p-dropdown [options]="allFedexAccounts" dataKey="id" optionLabel="name" filterBy="name" placeholder="Select an account" [(ngModel)]="selectedFedexAcc" [ngModelOptions]="{ standalone: true }"></p-dropdown>
                            </ng-container>
                        </div>
                        <div class="p-col-4 p-d-flex" style="flex-direction: row-reverse">
                            <button pButton pRipple type="button" icon="pi pi-times" (click)="onShipmentDialogClose()" class="p-button-rounded p-dialog-header-icon p-dialog-header-close"></button>
                        </div>
                    </div>
                </ng-container>
            </ng-template>
        
            <div *ngIf="selectedCarrier && selectedCarrier.name && selectedCarrier.name.toLowerCase() == 'easypost'">
                <app-easypost-shipment [displayAddPackage]="displayShipmentDialog" [detailsObj]="soDetails" [selectedCarrier]="selectedCarrier" [channel]="channel" (onLabelCreate)="createLabel($event)" (onClose)="onShipmentDialogClose()" (onStepChange)="onStepChange($event)"></app-easypost-shipment>
            </div>
            <div *ngIf="selectedCarrier && selectedCarrier.name && selectedCarrier.name.toLowerCase() == 'fedex'">
                <app-fedex-shipment [detailsObj]="soDetails" [channel]="channel" [vendorFedexInfo]="vendorFedexInfo" [selectedCarrier]="selectedCarrier" [fedexAccountInfo]="fedexAccountInfo" [allFedexAccounts]="allFedexAccounts" [selectedFedexAcc]="selectedFedexAcc" [allShippingMethods]="allShippingMethods" [displayAddPackage]="displayShipmentDialog" (onFedexLabelCreate)="createFedexLabel($event)" (onClose)="onShipmentDialogClose()" (onStepChange)="onStepChange($event)"></app-fedex-shipment>
            </div>
            <div *ngIf="selectedCarrier && selectedCarrier.name && selectedCarrier.name.toLowerCase() == 'ups'">
                <app-ups-shipment [detailsObj]="soDetails" [channel]="channel" [vendorUpsInfo]="vendorUpsInfo" [selectedCarrier]="selectedCarrier" [fedexAccountInfo]="fedexAccountInfo" [allUpsAccounts]="allUpsAccounts" [allShippingMethods]="allShippingMethods" [displayAddPackage]="displayShipmentDialog" (onSuccessfullUpsShipment)="onSuccessfullUpsShipment($event)" (onClose)="onShipmentDialogClose()" (onStepChange)="onStepChange($event)"></app-ups-shipment>
            </div>
        </p-dialog>
        
        <ng-container *ngIf="soDetails && displayAppliedAmountViewModal">
            <app-applied-amount-view-modal [id]="soDetails?.id" [channelName]="soChannel.SALES_ORDER" [soDetails]="soDetails" [displayAppliedAmountViewModal]="displayAppliedAmountViewModal" (onClose)="onCloseAppliedAmountModal()"></app-applied-amount-view-modal>
        </ng-container>
        
        <!-- Inventory Overview -->
        <app-inventory-module-overview-dialogs *ngIf="displayInventoryOverview" [displayOverview]="displayInventoryOverview" [overviewRefId]="inventoryOverviewRefId" [overviewRefNumber]="inventoryOverviewRefNumber" [overviewModule]="inventoryOverviewModule" (onCancel)="closeViewPopup()"> </app-inventory-module-overview-dialogs>
        
        <!-- Credit Memo Selection Modal -->
        <div *ngIf="soDetails?.accountId">
            <app-apply-credit-memo [accountId]="soDetails.accountId" [displayCreditSelect]="displayCreditSelect" [salesOrderId]="soDetails?.id" [reloadData]="shouldreloadCreditMemos" (onCloseCreditMemoSelectionModal)="onCloseCreditMemoSelectionModal($event)" (appliedCreditMemoEventEmitter)="onApplyCreditMemo($event)"> </app-apply-credit-memo>
        </div>
        
        <!-- Approval Details -->
        <app-approval-details *ngIf="displayViewApproval" [displayViewApproval]="displayViewApproval" [approvalTypeInfo]="approvalTypeInfo" (approvalStatusChange)="handleApprovalStatus($event.isUpdate)" (cancelClick)="displayViewApproval = false"> </app-approval-details>
        
    </p-tabPanel>
    <p-tabPanel header="Impacts on G/L">
        <app-inventory-impacts-gl [selectedId]="soId" [objectTypeId]="transactionTypeIds.SalesOrder" [callApi]="glApiCall"></app-inventory-impacts-gl>
    </p-tabPanel>
</p-tabView>